// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inner_box .is-current>.el-tree-node__content .custom_label{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
